import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState, } from "react";
import { Steper } from "../../../../components/event/steper/Steper";
import { Box, Drawer, useMediaQuery, useTheme, } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AdultsInfoForm } from "../AdultInfo";
import { ImportantInfoForm } from "../ImportantInfo";
import { PersonalInfoForm } from "../PersonalInfo";
import { ChildrenInfoForm } from "../ChildrenInfo";
import { useForm } from "react-hook-form";
import { PButton } from "@ui/components/buttons/PButton";
import { ArrowLeft2, MessageQuestion, Profile2User, User, } from "iconsax-react";
import { FormSummary } from "../FormSummary";
import { ConfirmDialog } from "../ConfirmDialog";
import { SuccessMsg } from "../SuccessMsg";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { ImportantInfoRegistertionAsync } from "@application/features/importantInformation/importantInfoThunk";
import { ChildRegistertionAsync } from "@application/features/children/childrenThunk";
import { AdultRegistertionAsync } from "@application/features/adult/adultThunk";
import { PersonalInfoRegistertionAsync } from "@application/features/personalInfo/personalInfoThunk";
import { ArrowRightIcon, EmojiKid } from "@ui/icons/CustomIcons";
import { useNavigate } from "react-router-dom";
import { FormWraper } from "@ui/components/event/wraper/FormWraper";
import { FormScrollable } from "@ui/components/event/wraper/FormScrollable";
import { useTranslation } from "react-i18next";
import { CreateTransportAsync } from "@application/features/transport/transportThunk";
import { TransportSelection } from "../Transport";
export const Home = ({ handleLogoPosition }) => {
    const { personalInfo } = useAppSelector((state) => state.person);
    const { linkVerification } = useAppSelector((state) => state.event);
    const { control, handleSubmit, setError, setValue, clearErrors, getValues, trigger, watch, reset, formState: { errors }, } = useForm({
        mode: "onChange",
    });
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const isXsUp = useMediaQuery(theme.breakpoints.up("xs"));
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    const isAbove1024 = useMediaQuery("(min-width:1025px)");
    const isBelow390 = useMediaQuery("(max-width:391px)");
    const isOnly1152 = useMediaQuery(theme.breakpoints.between(1152, 1153)); // macbook screen size
    const [open, setOpen] = useState(false);
    const [IsSuccess, setIsSuccess] = useState(false);
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };
    const handleTransportChange = (id) => {
        setTransportId(id);
    };
    const watchedValues = watch();
    const formValues = watch();
    const navigate = useNavigate();
    const [transportId, setTransportId] = useState(null);
    const dispatch = useAppDispatch();
    const [activeStep, setActiveStep] = useState(1);
    const [isConfirm, setisConfirm] = useState(false);
    const tabValue = watch("PersonalInfo.Option");
    const adultsCount = watch("PersonalInfo.AdultsCount");
    const childrenCount = watch("PersonalInfo.ChildrenCount");
    const [importantInfoId, setImportantInfoId] = useState(null);
    const [adultsInfo, setAdultsInfo] = useState([]);
    const [childrenInfo, setChildrenInfo] = useState([]);
    const eventType = "family";
    const handleAdultsChange = (updatedAdults) => {
        setAdultsInfo(updatedAdults);
    };
    const handleChildrenChange = (updatedChildren) => {
        setChildrenInfo(updatedChildren);
    };
    const handleImportantInfoChange = (newId) => {
        setImportantInfoId(newId);
    };
    const handleNext = async () => {
        const isValid = await trigger();
        if (!isValid)
            return;
        await SaveFormData(activeStep, getValues());
        let nextStep = activeStep;
        const currentTabValue = Number(tabValue);
        const currentAdultsCount = Number(watch("PersonalInfo.AdultsCount")) || 0;
        const currentChildrenCount = Number(watch("PersonalInfo.ChildrenCount")) || 0;
        // For tabValue = 1 (coming alone)
        if (currentTabValue === 1) {
            if (activeStep === 1) {
                nextStep = 4; // Skip Adults and Children, go to Transport
            }
            else if (activeStep === 4) {
                nextStep = 5; // From Transport go to ImportantInfo
            }
        }
        // For tabValue = 2 (coming with introduction)
        else if (currentTabValue === 2) {
            if (activeStep === 1) {
                // nextStep = currentAdultsCount > 0 ? 2 : 4; // Skip Adults if count is 0
                nextStep = 4;
            }
            else if (activeStep === 2) {
                nextStep = 4; // Skip Children, go to Transport
            }
            else {
                nextStep = activeStep + 1;
            }
        }
        // For tabValue = 3 (normal progression)
        else if (currentTabValue === 3) {
            if (activeStep === 1) {
                nextStep =
                    currentAdultsCount > 0 ? 2 : currentChildrenCount > 0 ? 3 : 4;
            }
            else if (activeStep === 2) {
                nextStep = currentChildrenCount > 0 ? 3 : 4;
            }
            else {
                nextStep = activeStep + 1;
            }
        }
        setActiveStep(nextStep);
    };
    const handleBack = () => {
        let prevStep = activeStep;
        const currentTabValue = Number(tabValue);
        const currentAdultsCount = Number(watch("PersonalInfo.AdultsCount")) || 0;
        const currentChildrenCount = Number(watch("PersonalInfo.ChildrenCount")) || 0;
        // For tabValue = 1 (coming alone)
        if (currentTabValue === 1) {
            if (activeStep === 5) {
                prevStep = 4; // From ImportantInfo back to Transport
            }
            else if (activeStep === 4) {
                prevStep = 1; // From Transport back to PersonalInfo
            }
        }
        // For tabValue = 2 (coming with introduction)
        else if (currentTabValue === 2) {
            if (activeStep === 5) {
                prevStep = 4; // From ImportantInfo back to Transport
            }
            else if (activeStep === 4) {
                // prevStep = currentAdultsCount > 0 ? 2 : 1; // Go back to Adults if count > 0, otherwise PersonalInfo
                prevStep = 1;
            }
            else if (activeStep === 2) {
                prevStep = 1; // From Adults back to PersonalInfo
            }
        }
        // For tabValue = 3 (normal progression)
        else if (currentTabValue === 3) {
            if (activeStep === 5) {
                prevStep = 4;
            }
            else if (activeStep === 4) {
                prevStep =
                    currentChildrenCount > 0 ? 3 : currentAdultsCount > 0 ? 2 : 1;
            }
            else if (activeStep === 3) {
                prevStep = currentAdultsCount > 0 ? 2 : 1;
            }
            else if (activeStep === 2) {
                prevStep = 1;
            }
        }
        setActiveStep(prevStep);
    };
    const SaveFormData = async (step, formData) => {
        let stepData;
        switch (step) {
            case 1:
                stepData = {
                    ...formData.PersonalInfo,
                    Id: personalInfo?.id,
                    UserId: linkVerification?.data?.userId,
                    InvitationId: linkVerification?.data?.invitationId,
                    ...(formData.PersonalInfo?.Option !== 1 && {
                        AdultsCount: Number(formData.PersonalInfo?.AdultsCount),
                    }),
                    ...(formData.PersonalInfo?.Option === 3 && {
                        ChildrenCount: Number(formData.PersonalInfo?.ChildrenCount),
                    }),
                    AttendanceDateIds: formData.PersonalInfo?.AttendanceDateIds,
                    WillYouAttendEvent: true,
                    ShirtSize: "not required",
                    DateOfBirth: formData.PersonalInfo?.DateOfBirth
                        ? new Date(Date.UTC(new Date(formData.PersonalInfo.DateOfBirth).getFullYear(), new Date(formData.PersonalInfo.DateOfBirth).getMonth(), new Date(formData.PersonalInfo.DateOfBirth).getDate())).toISOString()
                        : null,
                };
                try {
                    await dispatch(PersonalInfoRegistertionAsync(stepData))
                        .unwrap()
                        .then((resp) => {
                        if (Number(resp.option) == 2) {
                            try {
                                stepData = {
                                    AdultList: formData?.AdultInfo?.map((adult, index) => ({
                                        Id: (adultsInfo && adultsInfo[index]?.id) || undefined,
                                        PersonId: resp?.id,
                                        FirstName: adult.FirstName,
                                        MiddleName: adult.MiddleName,
                                        LastName: adult.LastName,
                                        Relationship: "introduction",
                                        Email: adult.Email,
                                        Gender: adult.Gender,
                                        ShirtSize: "not required",
                                        DateOfBirth: adult?.DateOfBirth
                                            ? new Date(Date.UTC(new Date(adult.DateOfBirth).getFullYear(), new Date(adult.DateOfBirth).getMonth(), new Date(adult.DateOfBirth).getDate())).toISOString()
                                            : null,
                                    })) || [],
                                    PersonId: resp?.id,
                                };
                                dispatch(AdultRegistertionAsync(stepData)).unwrap();
                            }
                            catch (error) { }
                        }
                    })
                        .finally(() => {
                        setActiveStep(5);
                    });
                }
                catch (error) { }
                break;
            case 2:
                stepData = {
                    AdultList: formData?.AdultInfo?.map((adult, index) => ({
                        Id: (adultsInfo && adultsInfo[index]?.id) || undefined,
                        PersonId: personalInfo?.id,
                        FirstName: adult.FirstName,
                        MiddleName: adult.MiddleName, // Optional
                        LastName: adult.LastName,
                        Relationship: adult.Relationship,
                        Email: adult.Email, // Optional
                        Gender: adult.Gender,
                        ShirtSize: "not required",
                        DateOfBirth: adult?.DateOfBirth
                            ? new Date(Date.UTC(new Date(adult.DateOfBirth).getFullYear(), new Date(adult.DateOfBirth).getMonth(), new Date(adult.DateOfBirth).getDate())).toISOString()
                            : null,
                    })) || [],
                    PersonId: personalInfo?.id,
                };
                try {
                    await dispatch(AdultRegistertionAsync(stepData)).unwrap();
                }
                catch (error) { }
                break;
            case 3:
                stepData = {
                    ChildrenList: formData?.ChildrenInfo
                        ? formData.ChildrenInfo.map((child, index) => ({
                            Id: (childrenInfo && childrenInfo[index]?.id) || undefined,
                            PersonId: personalInfo?.id,
                            FirstName: child.FirstName,
                            MiddleName: child.MiddleName, // Optional
                            LastName: child.LastName,
                            Relationship: child.Relationship,
                            Gender: child.Gender, // Optional
                            ShirtSize: "not required", // Optional
                            DateOfBirth: child?.DateOfBirth
                                ? new Date(Date.UTC(new Date(child.DateOfBirth).getFullYear(), new Date(child.DateOfBirth).getMonth(), new Date(child.DateOfBirth).getDate())).toISOString()
                                : null,
                        }))
                        : [],
                    PersonId: personalInfo?.id,
                };
                try {
                    await dispatch(ChildRegistertionAsync(stepData)).unwrap();
                }
                catch (error) { }
                break;
            case 4:
                stepData = {
                    ...formData.Transport,
                    Id: transportId ? transportId : undefined,
                    PersonId: personalInfo?.id,
                    DoYouWantTransport: true,
                    //String(formData?.Transport?.DoYouWantTransport) === "true",
                    IsParkingRequired: String(formData?.Transport?.IsParkingRequired) === "true",
                    TransportOption: formData?.Transport?.TransportOption
                        ? Number(formData?.Transport?.TransportOption)
                        : undefined,
                };
                try {
                    await dispatch(CreateTransportAsync(stepData)).unwrap();
                }
                catch (error) { }
                break;
            case 5:
                stepData = {
                    ...formData.ImportantInfo,
                    Id: importantInfoId,
                    UserId: linkVerification?.data?.userId,
                    InvitationId: linkVerification?.data?.invitationId,
                    Comments: formData.ImportantInfo?.Comments,
                    IsBusTransportRequired: String(formData.ImportantInfo?.IsBusTransportRequired) === "true",
                    IsDisability: String(formData.ImportantInfo?.IsDisability) === "true",
                    SeatsCount: Number(formData.ImportantInfo?.SeatsCount),
                    PersonId: personalInfo?.id,
                    DisabilityComments: String(formData.ImportantInfo?.IsDisability) === "true" ? formData.ImportantInfo?.DisabilityComments : "",
                    // DietaryRequirements:
                    //   formData.ImportantInfo?.DietaryRequirements?.map(
                    //     (item) => item.value
                    //   ) || [],
                };
                try {
                    await dispatch(ImportantInfoRegistertionAsync(stepData))
                        .unwrap()
                        .then((response) => {
                        setIsSuccess(true);
                        handleLogoPosition && handleLogoPosition("start");
                        setisConfirm(false);
                    });
                }
                catch (error) { }
                break;
            default:
        }
    };
    const validateImportantInfo = async () => {
        const isValid = await trigger();
        if (!isValid)
            return;
        setisConfirm(true);
    };
    const onSubmit = () => {
        SaveFormData(activeStep, getValues());
    };
    useEffect(() => { }, [activeStep, eventType, personalInfo]);
    const steps = useMemo(() => [
        { description: t("event.personalInfo"), icon: _jsx(User, {}) },
        { description: t("event.adults"), icon: _jsx(Profile2User, {}) },
        { description: t("event.childrenInfo"), icon: _jsx(EmojiKid, {}) },
        { description: t("event.transportInfo"), icon: _jsx(MessageQuestion, {}) },
        { description: t("event.importantInfo"), icon: _jsx(MessageQuestion, {}) },
    ], [t, i18n.language]);
    useEffect(() => {
        const container = document.querySelector(".events__main-content-wrapper");
        if (container) {
            container.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [activeStep]);
    const isTablet = useMediaQuery("(min-width:1024px)");
    return (_jsxs(Box, { children: [IsSuccess ? (_jsx(SuccessMsg, { eventType: eventType, onClick: () => { } })) : (_jsxs(Grid, { container: true, spacing: isBelow390 ? 8 : isAbove1024 ? 15 : 2.5, justifyContent: "space-between", p: 0, children: [_jsxs(Grid, { size: { xs: 12, sm: 12, md: isTablet ? 7 : 12, lg: 7 }, children: [_jsx(Steper, { activeStep: activeStep, eventType: eventType, tabValue: tabValue, steps: steps }), _jsx(FormWraper, { onClick: toggleDrawer(true), children: activeStep < 6 && (_jsxs(FormScrollable, { children: [activeStep === 1 && (_jsx(PersonalInfoForm, { control: control, eventType: eventType, errors: errors, personId: personalInfo?.id, setValue: setValue, setError: setError, clearErrors: clearErrors })), activeStep === 2 && eventType === "family" && (_jsx(AdultsInfoForm, { control: control, errors: errors, personId: personalInfo?.id, adultsCount: adultsCount, onAdultsChange: handleAdultsChange, selectedOption: tabValue, setValue: setValue, reset: reset })), activeStep === 3 && (_jsx(ChildrenInfoForm, { control: control, errors: errors, personId: personalInfo?.id, childrenCount: childrenCount, onChildrenChange: handleChildrenChange, setValue: setValue })), activeStep === 4 && (_jsx(TransportSelection, { control: control, errors: errors, personId: personalInfo?.id, onTransportChange: handleTransportChange, setValue: setValue })), activeStep === 5 && (_jsx(ImportantInfoForm, { personId: personalInfo?.id, control: control, errors: errors, eventType: eventType, onImportantInfoChange: handleImportantInfoChange, setValue: setValue })), activeStep < 6 && (_jsxs(Box, { mt: 3, display: "flex", flexDirection: { xs: "column-reverse", lg: "row" }, gap: 1, children: [activeStep >= 2 && eventType === "family" && (_jsx(PButton, { variant: "outlined", color: "ePrimary", fullWidth: true, onClick: handleBack, startIcon: _jsx(ArrowLeft2, {}), width: isMd ? "100%" : 160, minWidth: isMd ? "100%" : 160, maxWidth: isMd ? "100%" : 160, children: t("actions.back") })), activeStep !== 5 && (_jsx(PButton, { endIcon: _jsx(ArrowRightIcon, {}), fullWidth: true, variant: "contained", color: "ePrimary", onClick: handleNext, children: t("actions.saveAndNext") })), activeStep === 5 && eventType === "family" && (_jsx(PButton, { fullWidth: true, color: "ePrimary", endIcon: _jsx(ArrowRightIcon, {}), onClick: validateImportantInfo, children: t("actions.submitAll") }))] }))] })) })] }), _jsx(Grid, { size: { xs: 12, sm: 12, md: isTablet ? 5 : 12, lg: 5 }, children: _jsx(FormSummary, { activeStep: activeStep, eventType: "family", watchedValues: watchedValues }) })] })), _jsx(Drawer, { open: open, anchor: "right", onClose: toggleDrawer(false), PaperProps: {
                    backgroundImage: "url(/assets/images/event-bg.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }, children: _jsx(Box, { width: 330, px: 1, children: _jsx(FormSummary, { isDrawer: true, eventType: "family", activeStep: activeStep, watchedValues: watchedValues }) }) }), _jsx(ConfirmDialog, { isOpen: isConfirm, onConfirm: handleSubmit(onSubmit), onClose: () => setisConfirm(false), bodyText: t("event.configDialogText"), title: t("event.submitAllInformation") })] }));
};
